import {
  DataStoreModel,
  ModelTypes,
} from '../../dataStorePersistence/DataStoreModel';
import { Translator } from '../translator.interface';
import { User, UserBackend } from './users.interfaces';

export class UserTranslator implements Translator<UserBackend, User> {
  translateOneToBackendModel(resource: User): UserBackend {
    // TODO: validate model
    return {
      id: resource.id,
      accountId: resource.accountId,
      creatorAccountId: resource.creatorAccountId,
      modelType: ModelTypes.User,
      email: resource.email,
      phone: resource.phone,
      firstName: resource.firstName,
      lastName: resource.lastName,
      postalCode: resource.postalCode,
      inviteEmailStatus: resource.inviteEmailStatus,
      role: resource.role,
      accountType: resource.accountType,
      enabled: resource.enabled,
    };
  }

  translatePartialToBackendModel(
    resource: User,
  ): Partial<UserBackend> & Required<DataStoreModel> {
    const allProps = this.translateOneToBackendModel(resource);
    const partialProps: Partial<UserBackend> & Required<DataStoreModel> = {
      id: resource.id,
      modelType: ModelTypes.User,
    };
    Object.keys(resource).forEach((key) => {
      partialProps[key] = allProps[key];
    });
    return partialProps;
  }

  translate(resources: UserBackend[]): User[] {
    // TODO: validate model
    return resources.map((resource) => {
      return this.translateOne(resource);
    });
  }

  translateOne(resource: UserBackend): User {
    // TODO: figure out why dataStore return user parsed already?
    try {
      return {
        id: resource.id,
        accountId: resource.accountId,
        modelType: ModelTypes.User,
        email: resource.email,
        phone: resource.phone,
        firstName: resource.firstName,
        lastName: resource.lastName,
        postalCode: resource.postalCode,
        inviteEmailStatus: resource.inviteEmailStatus,
        role: resource.role,
        accountType: resource.accountType,
        enabled: resource.enabled,
      };
    } catch (error) {
      console.error('Error in user translator translateOne');
      return {} as User;
    }
  }
}
